export const parseIBKRXML = async (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = async (e) => {
      try {
        const text = e.target.result;

        // QFX / OFX Kontrolü
        if (text.includes('<OFX>') || text.includes('OFXHEADER')) {
            const positions = parseQFX(text);
            resolve(positions);
            return;
        }

        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(text, "text/xml");

        const parserError = xmlDoc.querySelector("parsererror");
        if (parserError) {
          throw new Error("XML dosyası işlenirken hata oluştu.");
        }

        const positionsMap = new Map();

        // 1. Önce "OpenPosition" verilerini kontrol et (En doğru anlık portföy verisi)
        const openPositions = xmlDoc.getElementsByTagName("OpenPosition");
        
        if (openPositions.length > 0) {
            for (let i = 0; i < openPositions.length; i++) {
                const pos = openPositions[i];
                let symbol = pos.getAttribute("symbol");
                const quantity = parseFloat(pos.getAttribute("position") || "0");
                const markPrice = parseFloat(pos.getAttribute("markPrice") || "0"); // Güncel fiyat
                const costPrice = parseFloat(pos.getAttribute("costBasisPrice") || "0"); // Birim Maliyet
                const currency = pos.getAttribute("currency"); // Para birimi

                let type = 'STOCK';
                const assetCategory = pos.getAttribute("assetCategory");
                
                if (assetCategory === 'CASH' || symbol.includes('.')) { 
                    if (!symbol.includes('.CURRENCY')) symbol += '.CURRENCY';
                    type = 'CURRENCY';
                } else if (pos.getAttribute("subCategory") === "ETF") {
                    type = 'ETF';
                }

                if (quantity !== 0) {
                     positionsMap.set(symbol, {
                        symbol,
                        shares: quantity,
                        price: markPrice,
                        cost: costPrice,
                        currency,
                        totalCost: quantity * costPrice,
                        date: new Date().toISOString().split('T')[0],
                        type
                    });
                }
            }
        } 
        
        // 2. Eğer OpenPosition yoksa, Trades üzerinden hesaplamaya çalış (Fallback)
        else {
            const trades = xmlDoc.getElementsByTagName("Trade");
            for (let i = 0; i < trades.length; i++) {
              const trade = trades[i];
              const assetCategory = trade.getAttribute("assetCategory");
              let symbol = trade.getAttribute("symbol");
              const quantity = parseFloat(trade.getAttribute("quantity") || "0");
              const cost = parseFloat(trade.getAttribute("cost") || "0"); 
              const closePrice = parseFloat(trade.getAttribute("closePrice") || "0");
              const tradeDate = trade.getAttribute("tradeDate");
              const currency = trade.getAttribute("currency");

              let type = 'STOCK';
              if (assetCategory === 'CASH') {
                  if (!symbol.includes('.CURRENCY')) symbol += '.CURRENCY';
                  type = 'CURRENCY';
              } else if (trade.getAttribute("subCategory") === "ETF") {
                  type = 'ETF';
              }

              if (!positionsMap.has(symbol)) {
                positionsMap.set(symbol, {
                  symbol,
                  shares: 0,
                  totalCost: 0,
                  price: closePrice,
                  currency,
                  type,
                  date: tradeDate
                });
              }

              const position = positionsMap.get(symbol);
              position.shares += quantity;
              position.totalCost += cost;
              if (closePrice > 0) position.price = closePrice;
              if (currency) position.currency = currency;
            }
        }
        
        const parsedTrades = [];
        positionsMap.forEach((pos) => {
          if (Math.abs(pos.shares) < 0.0001) return;
          
          let avgCost = pos.cost;
          if (openPositions.length === 0 && pos.shares !== 0) {
              avgCost = pos.totalCost / pos.shares;
          }

          const totalValue = pos.shares * pos.price;

          parsedTrades.push({
            symbol: pos.symbol,
            shares: pos.shares,
            price: pos.price,
            cost: avgCost, 
            currency: pos.currency,
            total: totalValue, 
            profitLoss: totalValue - (pos.shares * avgCost),
            date: pos.date,
            type: pos.type
          });
        });

        resolve(parsedTrades);
      } catch (error) {
        console.error('IBKR XML parse error:', error);
        reject(error);
      }
    };

    reader.onerror = (error) => reject(error);
    reader.readAsText(file);
  });
};

// QFX/OFX Parser Helper
const parseQFX = (text) => {
    // 1. Security List (TICKER mapping) parse et
    // <SECINFO>...<SECID><UNIQUEID>xxx</UNIQUEID>...</SECID>...<TICKER>yyy</TICKER>...</SECINFO>
    const secMap = new Map(); // UniqueID -> { Ticker, Name }
    
    // Basit regex ile SECINFO bloklarını bul
    const secInfoRegex = /<SECINFO>([\s\S]*?)<\/SECINFO>/g;
    let secMatch;
    
    while ((secMatch = secInfoRegex.exec(text)) !== null) {
        const content = secMatch[1];
        const uniqueIdMatch = /<UNIQUEID>(.*?)(\r|\n|<)/.exec(content);
        const tickerMatch = /<TICKER>(.*?)(\r|\n|<)/.exec(content);
        const nameMatch = /<SECNAME>(.*?)(\r|\n|<)/.exec(content);
        
        if (uniqueIdMatch && tickerMatch) {
            const uid = uniqueIdMatch[1].trim();
            secMap.set(uid, {
                ticker: tickerMatch[1].trim(),
                name: nameMatch ? nameMatch[1].trim() : ''
            });
        }
    }

    // 2. Positions Parse et
    const positions = [];
    // POSSTOCK ve POSMF (Mutual Fund) bloklarını ara
    const posRegex = /<(POSSTOCK|POSMF)>([\s\S]*?)<\/(POSSTOCK|POSMF)>/g;
    let posMatch;

    while ((posMatch = posRegex.exec(text)) !== null) {
        const content = posMatch[2];
        const uniqueIdMatch = /<UNIQUEID>(.*?)(\r|\n|<)/.exec(content);
        
        // Değerleri bul
        const unitsMatch = /<UNITS>(.*?)(\r|\n|<)/.exec(content);
        const priceMatch = /<UNITPRICE>(.*?)(\r|\n|<)/.exec(content);
        // Cost basis her zaman olmayabilir ama varsa alalım
        // IBKR QFX'inde <COSTBASIS> olmayabilir, manuel hesap gerekebilir.
        
        if (uniqueIdMatch && unitsMatch) {
            const uid = uniqueIdMatch[1].trim();
            const secInfo = secMap.get(uid);
            
            if (secInfo) {
                const quantity = parseFloat(unitsMatch[1].trim());
                const price = priceMatch ? parseFloat(priceMatch[1].trim()) : 0;
                
                // QFX genellikle anlık snapshot verir
                const totalValue = quantity * price;
                
                // Sembolü düzelt (örn: BRK.B)
                const symbol = secInfo.ticker;

                positions.push({
                    symbol: symbol,
                    shares: quantity,
                    price: price,
                    cost: 0, // QFX'den maliyet okumak zordur, kullanıcı elle girebilir veya 0 kalır
                    total: totalValue,
                    profitLoss: 0, // Maliyet olmadığı için hesaplanamaz
                    date: new Date().toISOString().split('T')[0],
                    type: posMatch[1] === 'POSMF' ? 'FUND' : 'STOCK',
                    description: secInfo.name
                });
            }
        }
    }
    
    return positions;
};
